import { Pipe, PipeTransform } from '@angular/core';
export type SortOrder = 'asc' | 'desc';

@Pipe({
  name: 'tableSort',
  standalone: true
})
export class TableSortPipe implements PipeTransform {
  transform(value: any[], sortOrder: SortOrder | string = 'asc', sortKey?: string): any {
    sortOrder = sortOrder && (sortOrder.toLowerCase() as any);

    if (!value || (sortOrder !== 'asc' && sortOrder !== 'desc')) return value;

    let sorted = [...value]; // Create a copy of the array

    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

    if (!sortKey) {
      sorted = sorted.sort((a, b) => {
        if (typeof a === 'number' && typeof b === 'number') return a - b;
        return collator.compare(String(a), String(b));
      });
    } else {
      sorted = sorted.sort((a, b) => {
        const firstItem = a[sortKey];
        const secondItem = b[sortKey];

        // Handle null/undefined values
        if (firstItem === null || firstItem === undefined) return 1; // Move null/undefined to end
        if (secondItem === null || secondItem === undefined) return -1; // Move null/undefined to end

        if (typeof firstItem === 'number' && typeof secondItem === 'number') {
          return firstItem - secondItem;
        }

        return collator.compare(String(firstItem), String(secondItem));
      });
    }

    return sortOrder === 'asc' ? sorted : sorted.reverse();
  }
}
